import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseDivider',
  props: {
    vertical: { type: Boolean },
    inset: {},
    color: {}
  },
  setup(__props: any) {

const props = __props;

const cssProps = computed(() => {
  return {
    '--background-color': props.color,
    '--inset-size': props.inset,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["divider", { vertical: _ctx.vertical, inset: _ctx.inset }]),
    style: _normalizeStyle(cssProps.value)
  }, null, 6))
}
}

})